import { useMutation, gql } from "@apollo/client"
import { PROCESS_FIELDS } from "./useQueryOrganisationTemplates"

const UPDATEPROCESS_MUTATION = gql`
  mutation UpdateProcess(
    $id: ID!
    $name: String!
    $steps: [ProcessStepInput!]!
    $after: ScheduleDateInput
    $due: ScheduleDateInput
    $pinning: ProcessPinningInput
    $inactive: Boolean
    $repeat: ProcessRepetitionInput
    $notify: ProcessNotifyInput
    $users: [ID!]!
    $groups: [ID!]!
    $locations: [ID!]!
    ) {       
      updateProcess(
        id: $id
        name: $name
        steps: $steps
        after: $after
        due: $due
        pinning: $pinning    
        inactive: $inactive    
        repeat: $repeat
        notify: $notify
        users: $users
        groups: $groups
        locations: $locations        
      ) {
        ${PROCESS_FIELDS}
      } 
  }
`

const UPDATEPROCESS_INACTIVE_MUTATION = gql`
  mutation UpdateProcessInactive(
    $id: ID!
    $inactive: Boolean!
    ) {       
      updateProcessInactive(id: $id, inactive: $inactive) {
        ${PROCESS_FIELDS}
      } 
  }
`

const COPYPROCESS_MUTATION = gql`
  mutation CopyProcess($id: ID!) {       
    copyProcess(id: $id) {
      ${PROCESS_FIELDS}
    }
  }
`

const DELETEPROCESS_MUTATION = gql`
  mutation DeleteProcess($id: ID!) {
    deleteProcess(id: $id)
  }
`

const useMutationUpdateProcess = () => useMutation(UPDATEPROCESS_MUTATION)

const useMutationUpdateProcessInactive = () => useMutation(UPDATEPROCESS_INACTIVE_MUTATION)

const useMutationCopyProcess = () => useMutation(COPYPROCESS_MUTATION)

const useMutationDeleteProcess = () => useMutation(DELETEPROCESS_MUTATION)

export { useMutationUpdateProcess, useMutationUpdateProcessInactive, useMutationCopyProcess, useMutationDeleteProcess }
